/* === Header cookie reader to display selected truck (truck_fitment) - START === */
(function () {
  function getCookie(name) {
    const nameEQ = name + "=";
    const parts = document.cookie.split(";");
    for (let i = 0; i < parts.length; i++) {
      let c = parts[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  function safeJsonParse(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  function readTruckFitment() {
    const raw = getCookie("truck_fitment");
    if (!raw) return null;

    const tryDecode = (s) => {
      try { return decodeURIComponent(s); } catch (_) { return s; }
    };

    // Cookie value is URL-encoded JSON, so we try a couple of decode variants
    const candidates = [
      raw,
      tryDecode(raw),
      tryDecode(raw.replace(/\+/g, "%20"))
    ];

    for (const c of candidates) {
      const parsed = safeJsonParse(c);
      if (parsed && typeof parsed === "object") return parsed;
    }

    return null;
  }

  function updateHeaderTruck() {
    const wrapper = document.getElementById("peragon-selected-truck");
    if (!wrapper) return;

    const line1 = wrapper.querySelector(".peragon-truck-line1");
    if (!line1) return;

    const t = readTruckFitment();
    if (!t) return;

    const year  = (t.year  || "").trim();
    const make  = (t.make  || "").trim();
    const model = (t.model || "").trim();

    let full = [year, make, model].filter(Boolean).join(" ");

    // Replace normal hyphens with non-breaking hyphens
    full = full.replace(/-/g, "\u2011"); // "F-150" instead of "F-150"

    line1.textContent = full;
  }

  document.addEventListener("DOMContentLoaded", updateHeaderTruck);

  // Optional: call this manually after you update the cookie in JS
  window.PeragonUpdateHeaderTruck = updateHeaderTruck;
})();
/* === Header cookie reader to display selected truck (truck_fitment) - END === */

/* === Affirm button click handler - START === */
(function () {
  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function onPromoClick(e) {
    const trigger = e.target.closest(".peragon-promobanner-trigger");
    if (!trigger) return;

    e.preventDefault();

    console.log('Affirm click event triggered.');

    // Placeholder: later you’ll open Klaviyo/Affirm modal here
    // window._klOnsite = window._klOnsite || [];
    // window._klOnsite.push(['openForm', 'FORM_ID']);

    // dataLayer push (wired to section settings via data attributes if desired later)
    // For now, keep it generic. If you want settings-driven values, we can inject them as data-* attrs.
    // pushDataLayer({
    //   event: "click_promotion",
    //   ecommerce: {
    //     creative_name: "Promo Banner",
    //     creative_slot: "promo banner",
    //     promotion_id: trigger.dataset.promoId || "0",
    //     promotion_name: "Promotion"
    //   }
    // });
  }

  document.addEventListener("click", onPromoClick);
})();
/* === Affirm button click handler - END === */


/* === Klaviyo form trigger (.klaviyo_form_trigger) - START === */
(function () {
  var DEFAULT_KLAVIYO_FORM_ID = 'R7RAQb';

  function openKlaviyoForm(formId) {
    if (!formId) return;

    try {
      var klData = JSON.parse(localStorage.getItem('klOnsite') || '{}');
      if (klData.modal && klData.modal.disabledForms) {
        delete klData.modal.disabledForms[formId];
      }
      if (klData.modal && klData.modal.viewedForms) {
        delete klData.modal.viewedForms[formId];
      }
      localStorage.setItem('klOnsite', JSON.stringify(klData));
    } catch (e) {}

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.klaviyo_form_trigger');
    if (!trigger) return;

    e.preventDefault();
    var formId =
      trigger.getAttribute('data-klaviyo-form-id') ||
      trigger.getAttribute('data-klaviyo-form') ||
      DEFAULT_KLAVIYO_FORM_ID;
    openKlaviyoForm(formId);
  });
})();
/* === Klaviyo form trigger - END === */


/* === Cover animation slider (sprite background) - START === */
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.peragon-cover-animation');

  sections.forEach((section) => {
    const frames = parseInt(section.dataset.frames, 10) || 12;
    const spriteUrl = section.dataset.sprite;
    const cell = section.querySelector('.peragon-cover-animation__cell');
    const slider = section.querySelector('.peragon-cover-animation__slider input[type="range"]');

    if (!cell || !slider || !spriteUrl) return;

    // Use the raw asset URL – no Shopify resizing
    cell.style.backgroundImage = `url('${spriteUrl}')`;

    const maxIndex = Math.max(frames - 1, 1);

    function updateFromSlider() {
      const index = parseInt(slider.value, 10) || 0;
      // Map frame index (0..maxIndex) to 0..100% background-position
      const percent = (index / maxIndex) * 100;
      cell.style.backgroundPosition = `${percent}% center`;
    }

    slider.addEventListener('input', updateFromSlider);
    slider.addEventListener('change', updateFromSlider);

    // Initial frame
    updateFromSlider();
  });
});
/* === Cover animation slider (sprite background) - END === */
